function newsSelectionMenu() {
    
  const menu = <HTMLElement> document.getElementById('news-overview-menu');
  const filter = <HTMLElement> document.getElementById('news-sort-widget');

  if (!menu || !filter) return;

  window.addEventListener('scroll', () => {
    const position = filter.getBoundingClientRect().top;
    if (position < -100) {
      menu.style.transform = 'translateY(0px)'
    }
    if (position >= -100) {
      menu.style.transform = 'translateY(-100%)'
    }
  });
}
newsSelectionMenu();


function newsSelectionScroll() {
  
  const sortWidget   = <HTMLElement> document.getElementById('news-sort-widget');
  const toSortWidget = <HTMLElement> document.getElementById('to-sort-widget');

  if (!sortWidget || !toSortWidget) return;

  toSortWidget.addEventListener('click', () => {
    const position = sortWidget.offsetTop;
    window.scroll({ top: position - 100, left: 0, behavior: 'smooth' });
  },false);
}
newsSelectionScroll();